var render = function render() {
    var _vm_repayObj, _vm_repayObj1, _vm_repayObj2, _vm_repayObj3;
    var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
    return _c('x-popup', {
        style: {
            width: '100%'
        },
        attrs: {
            "value": _vm.value,
            "title": "Liquida esta factura entera",
            "safeAreaInsetBottom": true,
            "position": "bottom",
            "closeable": "",
            "close-icon-position": "top-right",
            "teleport": "body",
            "round": ""
        },
        on: {
            "opened": _setup.onOpenedPopup,
            "closed": _setup.onClosedPopup,
            "click-overlay": function($event) {
                return _setup.emit('close');
            },
            "click-close-icon": function($event) {
                return _setup.emit('close');
            }
        }
    }, [
        _c('div', {
            class: _vm.$style.container
        }, [
            _c('p', {
                class: _vm.$style.title
            }, [
                _vm._v("Reembolso total restante")
            ]),
            _c('p', {
                class: _vm.$style.money
            }, [
                _vm._v(" $" + _vm._s(_setup.formatAmount((_vm_repayObj = _vm.repayObj) === null || _vm_repayObj === void 0 ? void 0 : _vm_repayObj.leftBalance)) + " "),
                ((_vm_repayObj1 = _vm.repayObj) === null || _vm_repayObj1 === void 0 ? void 0 : _vm_repayObj1.remainingBalance) && ((_vm_repayObj2 = _vm.repayObj) === null || _vm_repayObj2 === void 0 ? void 0 : _vm_repayObj2.remainingBalance) > 0 ? _c('s', [
                    _vm._v(" $" + _vm._s(_setup.formatAmount((_vm_repayObj3 = _vm.repayObj) === null || _vm_repayObj3 === void 0 ? void 0 : _vm_repayObj3.remainingBalance)) + " ")
                ]) : _vm._e()
            ]),
            _c('van-button', {
                class: _vm.$style.btn,
                attrs: {
                    "block": ""
                },
                on: {
                    "click": function($event) {
                        var _vm_repayObj;
                        _setup.trackClick();
                        _setup.goRepay((_vm_repayObj = _vm.repayObj) === null || _vm_repayObj === void 0 ? void 0 : _vm_repayObj.formKey);
                    }
                }
            }, [
                _vm._v(" Reembolsar ahora ")
            ])
        ], 1)
    ]);
};
var staticRenderFns = [];
export { render, staticRenderFns };
